var _defs, _rect, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "IoT logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iotg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 116,
    height: 116,
    rx: 24,
    fill: "#0f172a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#iotg)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 24v22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 82v22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 64h22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 64h22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 38l15 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 75l15 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 38L75 53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 90l15-15"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 18,
    fill: "#00BCD4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 24,
    r: 7,
    fill: "#22D3EE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 104,
    r: 7,
    fill: "#22D3EE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 64,
    r: 7,
    fill: "#22D3EE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 64,
    r: 7,
    fill: "#22D3EE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 6,
    fill: "#38BDF8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 38,
    r: 6,
    fill: "#38BDF8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 90,
    r: 6,
    fill: "#38BDF8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 6,
    fill: "#38BDF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotLogo);
export default __webpack_public_path__ + "static/media/iotLogo.715bf548ddb26c4984bdf089d79076d7.svg";
export { ForwardRef as ReactComponent };